import React, { useState } from 'react'
import ValidatePassword from '../../../components/ValidatePassword'
import { useHistory } from 'react-router-dom'
import routes from '../../../config/routes'
import Private from '../../../components/Private'
import { Container } from '../styles'
import Text from '../../../components/Text'
import Button from '../../../components/Button'
import Icon from '../../../components/Icon'
import ChangeEmailForm from '../../../forms/ChangeEmail'

interface Props {

}

const ChangeEmailScreen: React.FC<Props> = () => {
  const [validated, setValidated] = useState(false)
  const history = useHistory()

  return (
    <Private>
      {!validated ? (
        <ValidatePassword
          title="ALTERAR EMAIL"
          onValidation={() => setValidated(true)}
          onCancel={() => history.push(routes.settings.security.index.path)}
        />
      ) : (
        <Container>
          <Text
            tag="h1"
          >
            <Button
              label={(
                <Icon
                  name="close"
                />
              )}
              smallPadding
              backgroundColor="transparent"
              onClick={() => history.push(routes.settings.security.index.path)}
            />
            {' '}Alterar email
          </Text>

          <ChangeEmailForm
            onSubmit={() => history.push(routes.settings.security.index.path)}
          />
        </Container>
      )}
    </Private>
  )
}

export default ChangeEmailScreen
